import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 55783 41114"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974340247664">
        <path
          d="M55482 2282c34 16 69 34 103 50 26 13 56 22 82 33 155 53 207 20-185-83zM43272 7455c-6751-348-12904 3387-17961 7455-192-190-414-346-659-466 1506-3041 2795-6233 4872-8954-7 9-13 17-16 20 14-16 69-88 30-37 1633-2124 3975-3832 6695-4215-12 2-25 3-27 3 38-2 150-22 48-6 616-75 1242-79 1858 0-206-20 24 4 75 13 367 35 1301 333 1361 373 1542 621 2743 1886 3380 3395-2-5-4-11-5-13 13 32 44 102 21 51 315 784 539 1614 605 2457-90-33-181-61-277-76zM28411 22496c323 321 995 1103 1098 1247 1452 1818 2310 4043 2616 6330 318 2276 174 6270-1350 8154-725 978-2029 1698-2989 1648 2328-6717-3971-12681-3262-19361-2 12-2 13-2 31 49-387 135-772 253-1145 16-10 30-23 46-33 1253 980 2487 1986 3590 3129zm-7332-7009c-79 130-153 265-222 406-5838 1737-13876 4166-18434-1283 7 6 7 8 13 14-969-1239-1423-2836-1223-4390 3468 803 7015 345 10524 579h-2c3512 688 6751 2433 9958 3957-239 201-445 441-614 717zM3815 8489c5 28 3 20-1 0h1zm27997-5315c3-2 6-5 9-7-30 23-78 58-9 7zm12113 946c-2894-6206-11499-4759-15020 97-2441 2952-3871 6539-5548 9935h-27c-15821-35799-41972 14505-2869 3202-54 659 349 1127 638 1653-4123 5063-8968 14419-2035 19180 3326 1881 8427 4493 11883 1715 5809-6602 1608-17167-5225-21453 114-176 199-370 259-569 10684 3615 22130-1405 17944-13760z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
